<section class="section white-100">
  <div class="section-container">
    <div class="section-discover-power-text padd-48">
      <div class="discover-power-content-basic align-items-c">
        <div class="discover-power-heading align-c">
          {{ termData?.header }}
        </div>
        <div class="landing-btn align-c">
          <a
            href="{{ termData.button.url | urlParams:queryParams}}"
            target="{{ termData.button.target }}"
            class="btn btn-full"
            >{{ termData.button.text }}</a
          >
        </div>
      </div>
    </div>
  </div>
</section>
